import { decode } from "jsonwebtoken";

export const getToken = (token_name) => {
  const token = sessionStorage.getItem(token_name);
  if (token === "null") {
    return null;
  }
  return token;
};
export const getTokenDecode = (token) => {
  return decode(token);
};
